import { AppSetting } from '@app/settings/shared/setting.model';
import { Component, HostBinding } from '@angular/core';
import { IAppSetting } from '@app/settings/shared/setting.interface';
import { LoginStatusModel } from '@app/security/shared/login-status-change.model';
import { LoginStatusService } from '@app/security/shared/login-status.service';
import { SettingsService } from '@app/settings/shared/settings.service';
import { faAngleDoubleRight, faAngleDoubleLeft } from '@fortawesome/pro-light-svg-icons';

const menuCollapseSettingId = 'aujsMenuIsCollapsed';

@Component({
  selector: 'acs-primary-nav-v',
  styleUrls: ['primary-nav-v.scss'],
  templateUrl: 'primary-nav-v.component.html'
})
export class PrimaryNavVComponent {
  @HostBinding('class.collapsed') menuCollapsed = false;
  public menuCollapseAppSetting: IAppSetting<any>;
  public collapsedStateIcon = this.menuCollapsed ? faAngleDoubleRight : faAngleDoubleLeft;

  constructor(
    private loginStatusService: LoginStatusService,
    private settingsService: SettingsService
  ) {
    this.loginStatusService.loginStatus.subscribe((loginStatus) => {
      this.onLoginStatusChange(loginStatus);
    });
  }

  public toggleMenuCollapse(): void {
    this.menuCollapsed = !this.menuCollapsed;
    this.collapsedStateIcon = this.menuCollapsed ? faAngleDoubleRight : faAngleDoubleLeft;

    if (this.menuCollapseAppSetting !== undefined) {
      this.menuCollapseAppSetting.data = this.menuCollapsed;
      this.settingsService.updateSetting(this.menuCollapseAppSetting).subscribe();
    }
  }

  private onCollapsedSettingRetrievedFromService(collapsedSetting): void {
    if (collapsedSetting !== undefined) {
      this.menuCollapseAppSetting = collapsedSetting;
      this.menuCollapsed = this.menuCollapseAppSetting.data;
    } else {
      this.menuCollapseAppSetting = new AppSetting();
      this.menuCollapseAppSetting.id = menuCollapseSettingId;
      this.menuCollapseAppSetting.data = this.menuCollapsed;
      this.settingsService.saveSetting(this.menuCollapseAppSetting).subscribe();
    }

    this.collapsedStateIcon = this.menuCollapsed ? faAngleDoubleRight : faAngleDoubleLeft;
  }

  private onLoginStatusChange(loginStatus: LoginStatusModel): void {
    if (loginStatus.loggedIn) {
      this.settingsService
        .getSettingById(menuCollapseSettingId)
        .subscribe((setting: IAppSetting<any>) => {
          this.onCollapsedSettingRetrievedFromService(setting);
        });
    } else {
      this.menuCollapseAppSetting = undefined;
    }
  }
}
